import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getMaintenanceHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: (action?.payload?.endpoint?action?.payload?.endpoint:"maintenance"), ...action.payload }),
		);
		yield put({
			type: types.GET_MAINTENANCE_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_MAINTENANCE_ERROR,
			payload,
		});
	}
}

export function* getMaintenanceWatcherSaga() {
	yield takeLatest(types.GET_MAINTENANCE_START, getMaintenanceHandlerSaga);
}

//create

//delete

function* deleteMaintenanceHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("maintenance", action.payload),
		);
		yield put({
			type: types.DELETE_MAINTENANCE_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_MAINTENANCE_ERROR,
			payload,
		});
	}
}

export function* deleteMaintenanceWatcherSaga() {
	yield takeLatest(
		types.DELETE_MAINTENANCE_START,
		deleteMaintenanceHandlerSaga,
	);
}

//update
